import React from "react";
import { getDataDefinitionForRulePage, getFormConfig } from "../Testing/FormTestData";
import { FormRule, FormRuleType } from "../Structure/FormRule";

import { getIfSimpleRule, getLogicExpressionResultElseIfAtEnd } from "../../Expressions/Testing/LogicData";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";
import { FormBuilder } from "../FormBuilder";

export const FormDesignerRuleStories = [
    new StoryNode(
        () => {
            let ui = getFormConfig();
            let datadef = getDataDefinitionForRulePage();
            ui.inputData = datadef;

            let expression1 = getLogicExpressionResultElseIfAtEnd();
            let rule1 = new FormRule(expression1, ["isEmployee", "income"]);
            Reflect.set(rule1.data!, "validationMessage", "It's not valid.");

            ui.rules = [rule1];
            return <FormBuilder form={ui}></FormBuilder>;
        },

        "Form Builder",
        "Rules",
        "Invalid Expression"
    ),

    new StoryNode(
        () => {
            let ui = getFormConfig();
            let datadef = getDataDefinitionForRulePage();
            ui.inputData = datadef;
            let expression1 = getIfSimpleRule();
            let changeFocus = new FormRule(expression1, []);
            changeFocus.ruleType = FormRuleType.CHANGE_FOCUS;
            Reflect.set(changeFocus.data!, "controlId", ui.getAllControls()[0].id);

            let changeValue = new FormRule(expression1, []);
            changeValue.ruleType = FormRuleType.CHANGE_VALUE;
            Reflect.set(changeValue.data!, "value", getIfSimpleRule());
            Reflect.set(changeValue.data!, "dataPath", "isEmployee");

            let controlEnabled = new FormRule(expression1, []);
            controlEnabled.ruleType = FormRuleType.CONTROL_ENABLED;
            Reflect.set(controlEnabled.data!, "controlId", [ui.getAllControls()[0].id]);

            let controlVisibility = new FormRule(expression1, []);
            controlVisibility.ruleType = FormRuleType.CONTROL_VISIBILITY;
            Reflect.set(controlVisibility.data!, "controlId", [ui.getAllControls()[0].id]);

            let exitForm = new FormRule(expression1, []);
            exitForm.ruleType = FormRuleType.EXIT_FORM;
            Reflect.set(exitForm.data!, "exitOnPath", ui.getOutcomes()[0]?.name);

            let validationRule = new FormRule(expression1, []);
            validationRule.ruleType = FormRuleType.VALIDATION;
            Reflect.set(validationRule.data!, "validationMessage", "It's invalid.");

            ui.rules = [changeFocus, changeValue, controlEnabled, controlVisibility, exitForm, validationRule];
            return <FormBuilder form={ui}></FormBuilder>;
        },

        "Form Builder",
        "Rules",
        "All Rules"
    ),

    new StoryNode(
        () => {
            let ui = getFormConfig();

            let datadef = getDataDefinitionForRulePage();
            ui.inputData = datadef;
            let expression1 = getIfSimpleRule();
            let changeFocus = new FormRule(expression1, []);
            changeFocus.ruleType = FormRuleType.CHANGE_FOCUS;

            let changeValue = new FormRule(expression1, []);
            changeValue.ruleType = FormRuleType.CHANGE_VALUE;

            let controlEnabled = new FormRule(expression1, []);
            controlEnabled.ruleType = FormRuleType.CONTROL_ENABLED;

            let controlVisibility = new FormRule(expression1, []);
            controlVisibility.ruleType = FormRuleType.CONTROL_VISIBILITY;

            let exitForm = new FormRule(expression1, []);
            exitForm.ruleType = FormRuleType.EXIT_FORM;

            let validationRule = new FormRule(expression1, []);
            validationRule.ruleType = FormRuleType.VALIDATION;

            ui.rules = [changeFocus, changeValue, controlEnabled, controlVisibility, exitForm, validationRule];

            return <FormBuilder form={ui}></FormBuilder>;
        },

        "Form Builder",
        "Rules",
        "Invalid Other Parameters"
    ),

    new StoryNode(
        () => {
            let ui = getFormConfig();

            return <FormBuilder form={ui}></FormBuilder>;
        },

        "Form Builder",
        "Rules",
        "Empty"
    ),
];
